<template>
  <nav-menu
    v-slot:default="slotProps"
    :color="color"
    :submit-event="submitEvent"
    :style="{ width: '200px' }"
  >
    <b-nav-item
      v-for="section in sections"
      :key="section.subsection"
      :href="`#${generateNavLink(section)}`"
      @click.prevent="slotProps.scrollIntoView(generateNavLink(section))"
      class="tsny_text-mid tsny_nav-item"
    >
      {{ formatNavText(section) }}
    </b-nav-item>
  </nav-menu>
</template>

<script>
import NavMenu from "../NavMenu";

export default {
  name: "ExamNav",
  components: { NavMenu },
  props: {
    color: {
      type: String,
      default: null
    },
    sections: {
      type: Array,
      default: null
    },
    submitEvent: {
      type: String,
      default: null
    }
  },
  methods: {
    generateNavLink(section) {
      return section.subsection
        ? section.subsection === "No Calculator"
          ? "noCalculator"
          : section.subsection
        : section.section;
    },
    formatNavText(section) {
      return section.subsection
        ? section.section === "Math"
          ? `Math (${section.subsection})`
          : section.subsection
        : section.section;
    }
  }
};
</script>

<style scoped></style>
